var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoltFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 2.25a.75.75 0 0 0-.738.616l-1 5.5A.75.75 0 0 0 4 9.25h2.085l-.82 4.103a.75.75 0 0 0 1.285.657l6.5-7a.75.75 0 0 0-.55-1.26H9.994l.727-2.544A.75.75 0 0 0 10 2.25H5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoltFilled);
export default ForwardRef;